module.exports = __webpack_public_path__ + "img/Louis-Image-01.8621a50a.jpg";